/* import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../Auth/AuthService";

const ProtectedRoute = ({ children }) => {
  return AuthService.isAuthenticated() ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
 */
import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../Auth/AuthService";

const ProtectedRoute = ({ allowedRoles, userRole, children }) => {
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" replace />; // Redirect to login if not authenticated
  }
  // Check if the user has the right role
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/404" replace />; // Redirect to 404 page
  }
  return children;
};

export default ProtectedRoute;
